import { render, staticRenderFns } from "./FeesForWeightAndNoiseMasterPage.vue?vue&type=template&id=388294c0&scoped=true&"
import script from "./FeesForWeightAndNoiseMasterPage.vue?vue&type=script&lang=js&"
export * from "./FeesForWeightAndNoiseMasterPage.vue?vue&type=script&lang=js&"
import style0 from "./FeesForWeightAndNoiseMasterPage.vue?vue&type=style&index=0&id=388294c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "388294c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JIT002729\\solas\\fc\\JIT\\frontDev_2\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('388294c0')) {
      api.createRecord('388294c0', component.options)
    } else {
      api.reload('388294c0', component.options)
    }
    module.hot.accept("./FeesForWeightAndNoiseMasterPage.vue?vue&type=template&id=388294c0&scoped=true&", function () {
      api.rerender('388294c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/feeMaster/feesForWeightAndNoiseMaster/FeesForWeightAndNoiseMasterPage.vue"
export default component.exports